import threepltekConfig from './tsp/3pltek';
import abceldConfig from './tsp/abceld';
import actioneldConfig from './tsp/actioneld';
import adaConfig from './tsp/ada';
import aieldConfig from './tsp/aield';
import aireldConfig from './tsp/aireld';
import alfaeldConfig from './tsp/alfaeld';
import alphaEldConfig from './tsp/alpha_eld';
import alsConfig from './tsp/als';
import ampmeldConfig from './tsp/ampmeld';
import apexeldConfig from './tsp/apexeld';
import apolloConfig from './tsp/apollo';
import apolloCloudConfig from './tsp/apollocloud';
import arezzotechConfig from './tsp/arezzotech';
import asapeldConfig from './tsp/asapeld';
import ascendConfig from './tsp/ascend';
import ateldConfig from './tsp/ateld';
import attConfig from './tsp/att';
import avanguardeldConfig from './tsp/avanguardeld';
import aventiseldConfig from './tsp/aventiseld';
import awaregpsConfig from './tsp/awaregps';
import axionrouteeldConfig from './tsp/axionrouteeld';
import azugaConfig from './tsp/azuga';
import bigroadConfig from './tsp/bigroad';
import bisonelogConfig from './tsp/bisonelog';
import bluehorseeldConfig from './tsp/bluehorseeld';
import blueinktechConfig from './tsp/blueinktech';
import bluesunsolutionseldConfig from './tsp/bluesunsolutionseld';
import bouncieConfig from './tsp/bouncie';
import budgetgpsConfig from './tsp/budgetgps';
import captaineldConfig from './tsp/captaineld';
import clubeldConfig from './tsp/clubeld';
import countingtruckseldConfig from './tsp/countingtruckseld';
import cyntrxConfig from './tsp/cyntrx';
import dashboardeldConfig from './tsp/dashboardeld';
import deltasolutionseldConfig from './tsp/deltasolutionseld';
import digitaleldConfig from './tsp/digitaleld';
import dragoneldConfig from './tsp/dragoneld';
import dreyevConfig from './tsp/dreyev';
import driverBookConfig from './tsp/driverbook';
import drivertechConfig from './tsp/drivertech';
import dsgelogsConfig from './tsp/dsgelogs';
import dynamiceldConfig from './tsp/dynamiceld';
import dypluseldConfig from './tsp/dypluseld';
import eighteighteighteldConfig from './tsp/eighteighteighteld';
import eld88Config from './tsp/eld88';
import eld99Config from './tsp/eld99';
import eldbooksConfig from './tsp/eldbooks';
import eldmandateConfig from './tsp/eldmandate';
import eldmandateprimeConfig from './tsp/eldmandateprime';
import eldnowConfig from './tsp/eldnow';
import eroadConfig from './tsp/eroad';
import evaeldConfig from './tsp/evaeld';
import evoeldConfig from './tsp/evoeld';
import expresswayeldConfig from './tsp/expresswayeld';
import extremeeldConfig from './tsp/extremeeld';
import ezlogzConfig from './tsp/ezlogz';
import ezlynkConfig from './tsp/ezlynk';
import factoreldConfig from './tsp/factoreld';
import firstgateConfig from './tsp/firstgate';
import flashelogsConfig from './tsp/flashelogs';
import fleetcompleteConfig from './tsp/fleetcomplete';
import fleetcompletehubConfig from './tsp/fleetcompletehub';
import fleethuntConfig from './tsp/fleethunt';
import fleetsharpConfig from './tsp/fleetsharp';
import fleetupConfig from './tsp/fleetup';
import flexeldConfig from './tsp/flexeld';
import fmConfig from './tsp/fm';
import fordeldConfig from './tsp/fordeld';
import fordproConfig from './tsp/fordpro';
import forwardthinkingConfig from './tsp/forwardthinking';
import forzaeldConfig from './tsp/forzaeld';
import g2geldConfig from './tsp/g2geld';
import geotabConfig from './tsp/geotab';
import globcomeldConfig from './tsp/globcomeld';
import gpsinsightConfig from './tsp/gpsinsight';
import gpstabConfig from './tsp/gpstab';
import gpstrackitConfig from './tsp/gpstrackit';
import grandeldConfig from './tsp/grandeld';
import greenlightConfig from './tsp/greenlight';
import hcssConfig from './tsp/hcss';
import hosconnectConfig from './tsp/hosconnect';
import hutchConfig from './tsp/hutch';
import infinityeldConfig from './tsp/infinityeld';
import intellishiftConfig from './tsp/intellishift';
import intimeeldConfig from './tsp/intimeeld';
import ironmaneldConfig from './tsp/ironmaneld';
import isaacConfig from './tsp/isaac';
import jjkellerConfig from './tsp/jjkeller';
import justeldConfig from './tsp/justeld';
import kinexaiotConfig from './tsp/kinexaiot';
import knighteldConfig from './tsp/knighteld';
import konexialConfig from './tsp/konexial';
import leadereldConfig from './tsp/leadereld';
import legacyeldConfig from './tsp/legacyeld';
import leoneldConfig from './tsp/leoneld';
import leveleldConfig from './tsp/leveleld';
import lightandtraveleldConfig from './tsp/lightandtraveleld';
import linxupConfig from './tsp/linxup';
import lioneldConfig from './tsp/lioneld';
import logpluseldConfig from './tsp/logpluseld';
import looktruckConfig from './tsp/looktruck';
import loopeldConfig from './tsp/loopeld';
import lucideldConfig from './tsp/lucideld';
import lunaeldConfig from './tsp/lunaeld';
import lytxConfig from './tsp/lytx';
import lytxv3Config from './tsp/lytxv3';
import maponConfig from './tsp/mapon';
import matrackConfig from './tsp/matrack';
import mavenConfig from './tsp/maven';
import maxeldConfig from './tsp/maxeld';
import mdmeldConfig from './tsp/mdmeld';
import milelogeldConfig from './tsp/milelogeld';
import mobilefleetConfig from './tsp/mobilefleet';
import monarchtrackingConfig from './tsp/monarchtracking';
import moonlightEldConfig from './tsp/moonlight_eld';
import motioneldConfig from './tsp/motioneld';
// Import individual TSP configurations
import motiveConfig from './tsp/motive';
import mylogseldConfig from './tsp/mylogseld';
import neroConfig from './tsp/nero';
import netradyneConfig from './tsp/netradyne';
import neweldworldConfig from './tsp/neweldworld';
import nextfleeteldConfig from './tsp/nextfleeteld';
import nextgenEldConfig from './tsp/nextgen_eld';
import nextraqConfig from './tsp/nextraq';
import nexuseldConfig from './tsp/nexuseld';
import nooreldConfig from './tsp/nooreld';
import omnitracsConfig from './tsp/omnitracs';
import onestepConfig from './tsp/onestep';
import onesystemeldConfig from './tsp/onesystemeld';
import ontimeeldConfig from './tsp/ontimeeld';
import optimaConfig from './tsp/optima';
import orbcommConfig from './tsp/orbcomm';
import orienteldConfig from './tsp/orienteld';
import ozodeldConfig from './tsp/ozodeld';
import pandaeldConfig from './tsp/pandaeld';
import paydConfig from './tsp/payd';
import pdsinceldConfig from './tsp/pdsinceld';
import peakeldConfig from './tsp/peakeld';
import peoplenetConfig from './tsp/peoplenet';
import phoenixConfig from './tsp/phoenix';
import platinumeldConfig from './tsp/platinumeld';
import popeldConfig from './tsp/popeld';
import premierridelogsConfig from './tsp/premierridelogs';
import prologsConfig from './tsp/prologs';
import prorideeldConfig from './tsp/prorideeld';
import qualitylogsConfig from './tsp/qualitylogs';
import quantumeldConfig from './tsp/quantumeld';
import quickelogsConfig from './tsp/quickelogs';
import randmcnallyConfig from './tsp/randmcnally';
import rastracConfig from './tsp/rastrac';
import redfoxConfig from './tsp/redfox';
import regulogEldConfig from './tsp/regulog_eld';
import ridehubConfig from './tsp/ridehub';
import rigbotConfig from './tsp/rigbot';
import ringeldConfig from './tsp/ringeld';
import roadEazyConfig from './tsp/roadeazy';
import roadguardlogsConfig from './tsp/roadguardlogs';
import rockeldConfig from './tsp/rockeld';
import rollingtransConfig from './tsp/rollingtrans';
import routeeldConfig from './tsp/routeeld';
import routemateConfig from './tsp/routemate';
import routeoneeldConfig from './tsp/routeoneeld';
import royaleldConfig from './tsp/royaleld';
import rtelogsConfig from './tsp/rtelogs';
import safelaneeldConfig from './tsp/safelaneeld';
import samsaraConfig from './tsp/samsara';
import selectivedriveConfig from './tsp/selectivedrive';
import sharpeldConfig from './tsp/sharpeld';
import simbaEldConfig from './tsp/simba_eld';
import smarteldsConfig from './tsp/smartelds';
import sparkleConfig from './tsp/sparkle';
import spireonConfig from './tsp/spireon';
import spliteldConfig from './tsp/spliteld';
import stateelogsConfig from './tsp/stateelogs';
import stellareldConfig from './tsp/stellareld';
import suneldConfig from './tsp/suneld';
import supporteldConfig from './tsp/supporteld';
import surfsightConfig from './tsp/surfsight';
import swiftConfig from './tsp/swift';
import switchboardConfig from './tsp/switchboard';
import synergyeldConfig from './tsp/synergyeld';
import teddyeldConfig from './tsp/teddyeld';
import teletracnavmanConfig from './tsp/teletracnavman';
import teletracnavmandirectorConfig from './tsp/teletracnavmandirector';
import telogisConfig from './tsp/telogis';
import tennaConfig from './tsp/tenna';
import thinkConfig from './tsp/think';
import timeeldConfig from './tsp/timeeld';
import tiveConfig from './tsp/tive';
import topcomplianceeldConfig from './tsp/topcomplianceeld';
import traccarConfig from './tsp/traccar';
import trackeaseeldConfig from './tsp/trackeaseeld';
import trackproConfig from './tsp/trackpro';
import tracktruckConfig from './tsp/tracktruck';
import traclogConfig from './tsp/traclog';
import transfloConfig from './tsp/transflo';
import trendyeldConfig from './tsp/trendyeld';
import trimbleConfig from './tsp/trimble';
import truckfordConfig from './tsp/truckford';
import truckxConfig from './tsp/truckx';
import trueroadeldConfig from './tsp/trueroadeld';
import trusteldConfig from './tsp/trusteld';
import ttConfig from './tsp/tt';
import txtesolutionConfig from './tsp/txtesolution';
import uniqueeldConfig from './tsp/uniqueeld';
import uniqueeldproConfig from './tsp/uniqueeldpro';
import usfasteldConfig from './tsp/usfasteld';
import uspowereldConfig from './tsp/uspowereld';
import uzbprimeeldConfig from './tsp/uzbprimeeld';
import verizonConfig from './tsp/verizon';
import vistaeldConfig from './tsp/vistaeld';
import vistracksConfig from './tsp/vistracks';
import vitalityeldConfig from './tsp/vitalityeld';
import vlogeldConfig from './tsp/vlogeld';
import vrdlogsConfig from './tsp/vrdlogs';
import vulcansolseldConfig from './tsp/vulcansolseld';
import webfleetConfig from './tsp/webfleet';
import wheelselogConfig from './tsp/wheelselog';
import wizefleeteldConfig from './tsp/wizefleeteld';
import xploreConfig from './tsp/xplore';
import zeroeldConfig from './tsp/zeroeld';
import zeromaxeldConfig from './tsp/zeromaxeld';
import zigzageldConfig from './tsp/zigzageld';
import zmseldConfig from './tsp/zmseld';
import zonarConfig from './tsp/zonar';
import zubieConfig from './tsp/zubie';
import { getTSPArray, setTSPConfigurations } from './utils';

// Add all TSP configurations here
// the order of the TSPs is important, as it determines the order of the TSPs in the dropdown
const tspConfigurations = [
  // Top TSPs
  motiveConfig,
  samsaraConfig,
  verizonConfig,
  geotabConfig,
  azugaConfig,
  linxupConfig,
  looktruckConfig,
  lioneldConfig,
  eroadConfig,
  apolloConfig,

  // Alphabeetical order
  threepltekConfig,
  abceldConfig,
  actioneldConfig,
  adaConfig,
  aieldConfig,
  aireldConfig,
  alfaeldConfig,
  alsConfig,
  alphaEldConfig,
  ampmeldConfig,
  apolloCloudConfig,
  apexeldConfig,
  arezzotechConfig,
  asapeldConfig,
  ascendConfig,
  ateldConfig,
  attConfig,
  avanguardeldConfig,
  aventiseldConfig,
  awaregpsConfig,
  axionrouteeldConfig,
  bigroadConfig,
  bisonelogConfig,
  blueinktechConfig,
  bluehorseeldConfig,
  bluesunsolutionseldConfig,
  bouncieConfig,
  budgetgpsConfig,
  captaineldConfig,
  countingtruckseldConfig,
  clubeldConfig,
  cyntrxConfig,
  dashboardeldConfig,
  deltasolutionseldConfig,
  digitaleldConfig,
  driverBookConfig,
  drivertechConfig,
  dsgelogsConfig,
  dragoneldConfig,
  dreyevConfig,
  dynamiceldConfig,
  dypluseldConfig,
  eighteighteighteldConfig,
  eld88Config,
  eld99Config,
  eldbooksConfig,
  eldnowConfig,
  eldmandateConfig,
  eldmandateprimeConfig,
  evaeldConfig,
  evoeldConfig,
  expresswayeldConfig,
  extremeeldConfig,
  ezlogzConfig,
  ezlynkConfig,
  factoreldConfig,
  firstgateConfig,
  flashelogsConfig,
  flexeldConfig,
  forzaeldConfig,
  fleetcompleteConfig,
  fleetcompletehubConfig,
  fleethuntConfig,
  fleetsharpConfig,
  fleetupConfig,
  fmConfig,
  fordeldConfig,
  fordproConfig,
  forwardthinkingConfig,
  g2geldConfig,
  globcomeldConfig,
  gpsinsightConfig,
  monarchtrackingConfig,
  gpstabConfig,
  gpstrackitConfig,
  grandeldConfig,
  greenlightConfig,
  hcssConfig,
  hosconnectConfig,
  hutchConfig,
  infinityeldConfig,
  intimeeldConfig,
  intellishiftConfig,
  ironmaneldConfig,
  isaacConfig,
  jjkellerConfig,
  justeldConfig,
  kinexaiotConfig,
  knighteldConfig,
  konexialConfig,
  leadereldConfig,
  legacyeldConfig,
  leoneldConfig,
  leveleldConfig,
  lightandtraveleldConfig,
  logpluseldConfig,
  loopeldConfig,
  lucideldConfig,
  lunaeldConfig,
  lytxConfig,
  lytxv3Config,
  maponConfig,
  matrackConfig,
  mavenConfig,
  maxeldConfig,
  mdmeldConfig,
  milelogeldConfig,
  mobilefleetConfig,
  moonlightEldConfig,
  motioneldConfig,
  mylogseldConfig,
  neroConfig,
  nooreldConfig,
  netradyneConfig,
  neweldworldConfig,
  nextfleeteldConfig,
  nextgenEldConfig,
  nextraqConfig,
  nexuseldConfig,
  omnitracsConfig,
  onestepConfig,
  onesystemeldConfig,
  ontimeeldConfig,
  optimaConfig,
  orbcommConfig,
  orienteldConfig,
  ozodeldConfig,
  pandaeldConfig,
  paydConfig,
  peakeldConfig,
  peoplenetConfig,
  phoenixConfig,
  premierridelogsConfig,
  platinumeldConfig,
  pdsinceldConfig,
  popeldConfig,
  prologsConfig,
  prorideeldConfig,
  qualitylogsConfig,
  quantumeldConfig,
  quickelogsConfig,
  randmcnallyConfig,
  rastracConfig,
  redfoxConfig,
  regulogEldConfig,
  rigbotConfig,
  ridehubConfig,
  ringeldConfig,
  roadEazyConfig,
  roadguardlogsConfig,
  rockeldConfig,
  rollingtransConfig,
  routeeldConfig,
  royaleldConfig,
  safelaneeldConfig,
  routemateConfig,
  routeoneeldConfig,
  rtelogsConfig,
  selectivedriveConfig,
  sharpeldConfig,
  simbaEldConfig,
  smarteldsConfig,
  sparkleConfig,
  spireonConfig,
  spliteldConfig,
  stellareldConfig,
  stateelogsConfig,
  supporteldConfig,
  surfsightConfig,
  suneldConfig,
  swiftConfig,
  switchboardConfig,
  synergyeldConfig,
  teddyeldConfig,
  trendyeldConfig,
  teletracnavmanConfig,
  teletracnavmandirectorConfig,
  telogisConfig,
  tennaConfig,
  thinkConfig,
  timeeldConfig,
  tiveConfig,
  topcomplianceeldConfig,
  traccarConfig,
  trackeaseeldConfig,
  traclogConfig,
  trackproConfig,
  tracktruckConfig,
  transfloConfig,
  trimbleConfig,
  truckfordConfig,
  truckxConfig,
  trueroadeldConfig,
  trusteldConfig,
  ttConfig,
  txtesolutionConfig,
  uniqueeldConfig,
  uniqueeldproConfig,
  usfasteldConfig,
  uspowereldConfig,
  uzbprimeeldConfig,
  vitalityeldConfig,
  vistaeldConfig,
  zeromaxeldConfig,
  vistracksConfig,
  vlogeldConfig,
  vrdlogsConfig,
  vulcansolseldConfig,
  webfleetConfig,
  wheelselogConfig,
  wizefleeteldConfig,
  xploreConfig,
  zeroeldConfig,
  zigzageldConfig,
  zmseldConfig,
  zonarConfig,
  zubieConfig,
  // Add more TSPs here as they're created
];

// Initialize the TSP configuration store
setTSPConfigurations(tspConfigurations);

// Export everything from utils
export * from './utils';
export * from './types';

// For backwards compatibility
export const tsps = getTSPArray();
